import React from 'react';

const AddIcon = () => {
  return (
    <svg width="13px" height="13px" viewBox="0 0 13 13" version="1.1" xmlns="http://www.w3.org/2000/svg">
 
    <title>ic_create_role</title>
    <desc>Created with Sketch.</desc>
    <g id="Role-Manage-Web-App" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.0-Role-:-Dashboard" transform="translate(-1266.000000, -101.000000)" fill="#97B041" fillRule="nonzero">
            <g id="Header--Tool">
                <g id="Create" transform="translate(1242.000000, 90.000000)">
                    <g id="btn-add-product">
                        <path d="M36.2187209,16.5625177 C36.5122306,16.5625177 36.7499696,16.8002567 36.7499696,17.0937665 L36.7499696,18.1562639 C36.7499696,18.4497737 36.5122306,18.6875127 36.2187209,18.6875127 L31.4374823,18.6875127 L31.4374823,23.4687513 C31.4374823,23.762261 31.1997433,24 30.9062335,24 L29.8437361,24 C29.5502263,24 29.3124873,23.762261 29.3124873,23.4687513 L29.3124873,18.6875127 L24.5312487,18.6875127 C24.237739,18.6875127 24,18.4497737 24,18.1562639 L24,17.0937665 C24,16.8002567 24.237739,16.5625177 24.5312487,16.5625177 L29.3124873,16.5625177 L29.3124873,11.7812791 C29.3124873,11.4877694 29.5502263,11.2500304 29.8437361,11.2500304 L30.9062335,11.2500304 C31.1997433,11.2500304 31.4374823,11.4877694 31.4374823,11.7812791 L31.4374823,16.5625177 L36.2187209,16.5625177 Z" id="ic_create_role"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
  )
}

export default AddIcon;